import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { Circle } from 'page/catalog/Circle/Circle'
import { employeeModal } from 'page/catalog/employee/EmployeeModal/EmployeeModalStore'
import { boutique } from 'page/catalog/employee/store/BoutiqueController'
import { employee } from 'page/catalog/employee/store/EmployeeStore'
import { MouseEvent } from 'react'
import { Me, saveAuth } from 'type/auth'
import { saveClient } from 'type/client'
import { emdash } from 'util/typo'

type Props = {
  data: Me
}

export const Employee = observer((props: Props) => {
  const { data } = props
  const { user_id, email, name, picture } = data.user
  const active = employee.manager_id === data.user.user_id

  const onAuth = useLatestCallback(() => {
    saveAuth(data.auth)
    saveClient(data.user.user_id, undefined)
    void boutique.login()
    employeeModal.close()
  })

  const onLogout = useLatestCallback((event: MouseEvent) => {
    event.stopPropagation()
    boutique.logout()
  })

  const onRemove = useLatestCallback((event: MouseEvent) => {
    event.stopPropagation()
    employee.remove(user_id)
  })

  return <Space button={!active} accent={active} gap={8} pad={8} round={6} opposite onClick={onAuth}>
    <Space gap={8}>
      <Circle size={32} image={picture} icon="person" />
      <Vertical left gap={4}>
        <Typo size={11} one upper medium>{name || emdash}</Typo>
        <Typo size={13} one secondary>{email || emdash}</Typo>
      </Vertical>
    </Space>
    {active && <Space button pad={8} round={6} center onClick={onLogout}>
      <Icon size={16} name="logout" />
    </Space>}
    {!active && <Space white pad={8} round={6} center onClick={onRemove}>
      <Icon size={16} name="delete" />
    </Space>}
  </Space>
})
